import { headerStyles } from "@insite/content-library/Widgets/Budget/BudgetManagementHeader";
import { reviewBudgetStyles } from "@insite/content-library/Widgets/Budget/ReviewBudget";
import { css } from "styled-components";

headerStyles.titleText = {
    variant: "h2",
    as: "h2",
    css: css`
        text-transform: capitalize;
    `,
};
